module.exports = __webpack_public_path__ + "static/media/tarjeta.9e664a32.png";